import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { UserSettingsService } from '@service/userSettings/user-settings.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-frequency-filter',
	templateUrl: './frequency-filter.component.html',
	styleUrls: ['./frequency-filter.component.scss'],
})
export class FrequencyFilterComponent implements OnChanges {
	@Input() isLoadingSearchResults: boolean = true;
	@Input() searchTruckForm: any = null;
	@Output() frequencyChange: EventEmitter<any> = new EventEmitter();

	frequencyFilter = {
		minLoadsPerWeek: this.userSettings.MINIMUM_FREQUENCY,
		monday: false,
		tuesday: false,
		wednesday: false,
		thursday: false,
		friday: false,
		saturday: false,
		sunday: false,
	};
	debouncer: Subject<any> = new Subject<any>();

	constructor(private cargochief: Cargochief, public userSettings: UserSettingsService) {
		this.debouncer.pipe(debounceTime(750)).subscribe((value) => {
			console.log('this.frequencyFilter: ', this.frequencyFilter);
			this.cargochief.setItem({ [CARGOCHIEF_KEYS.FREQUENCY_FILTER]: this.frequencyFilter });
			this.frequencyChange.emit();
		});
	}

	ngOnChanges() {
		if (this.searchTruckForm?.minLoadsPerWeek) {
			this.frequencyFilter.minLoadsPerWeek = this.searchTruckForm.minLoadsPerWeek;
		}
	}

	filterChanged() {
		this.debouncer.next(null);
	}
}
